import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { All_Panel_List } from "../../../ReduxStore/Slice/Superadmin/SuperAdminSlice";
import Content from "../../../Components/Dashboard/Content/Content";
import Chart from "react-apexcharts";

const Dashboard = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  const [AllData, setAllData] = useState({ loading: true, data: [] });
  const [activeUsersCount, setActiveUsersCount] = useState(0);
  const [inActiveUserCount, setInActiveUserCount] = useState(0);
  const getAreaChartOptions = (color) => ({
    chart: { type: "area", toolbar: { show: false }, sparkline: { enabled: true } },
    stroke: { curve: "smooth", width: 2 },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.6,
        opacityTo: 0.1,
        stops: [0, 90, 100],
      },
    },
    colors: [color],
    dataLabels: { enabled: false },
    xaxis: { labels: { show: false }, axisTicks: { show: false }, axisBorder: { show: false } },
    yaxis: { show: false },
    grid: { show: false },
    tooltip: {
      y: {
        formatter: (val) => `${val} Users`,
      },
    },
  });

  const fetchData = async () => {
    await dispatch(All_Panel_List())
      .unwrap()
      .then((response) => {
        const activeUsers = response.data.filter((user) => user.is_active === 0).length;
        const inActiveUsers = response.data.filter((user) => user.is_active === 1).length;

        setActiveUsersCount(activeUsers);
        setInActiveUserCount(inActiveUsers);

        setAllData({ loading: false, data: response.data });
      })
      .catch(() => { });
  };

  useEffect(() => {
    fetchData();
  }, []);

  if (AllData.loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "300px" }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  // Radial bar chart options
  const activeChartOptions = {
    chart: { type: "radialBar", sparkline: { enabled: true } },
    plotOptions: { radialBar: { hollow: { size: "50%" }, dataLabels: { show: false } } },
    colors: ["#28a745"],
  };

  const inactiveChartOptions = {
    chart: { type: "radialBar", sparkline: { enabled: true } },
    plotOptions: { radialBar: { hollow: { size: "50%" }, dataLabels: { show: false } } },
    colors: ["#ffc107"],
  };

  const activeSeries =
    AllData.data.length > 0 ? [Math.round((activeUsersCount / AllData.data.length) * 100)] : [0];

  const inactiveSeries =
    AllData.data.length > 0 ? [Math.round((inActiveUserCount / AllData.data.length) * 100)] : [0];

  const columnChartOptions = {
    chart: {
      type: "bar",
      toolbar: { show: false },
    },
    plotOptions: {
      bar: {
        borderRadius: 6,
        columnWidth: "40%",
      },
    },
    colors: ["#007bff", "#28a745", "#ffc107"],
    dataLabels: { enabled: true },
    xaxis: {
      categories: ["Total Panel", "Active", "Inactive"],
    },
    grid: {
      borderColor: "#e0e0e0",
      strokeDashArray: 4,
    },
    tooltip: {
      y: {
        formatter: (val) => `${val} Users`,
      },
    },
  };

  const columnChartSeries = [
    {
      name: "Users",
      data: [AllData.data.length, activeUsersCount, inActiveUserCount],
    },
  ];

  return (
    <Content Page_title="" button_status={false}>
      <div className="container-fluid py-4">
        {location.pathname === "/super/dashboard" ? (
          <div>
            <div className="row g-4">
              {/* Total Panel Card */}
              <div className="col-12 col-sm-6 col-lg-4">
                <div className="card shadow-sm ">
                  <div className="card-body">
                    <div className="">
                      <div className="d-flex align-items-center">
                        <div className="flex-grow-1">
                          <h6 className="card-title mb-1 fw-normal">Total Panel</h6>
                          <h2 className="mb-0 fw-bold">{AllData.data.length}</h2>
                        </div>
                        <div className="flex-shrink-0 me-3">
                          <div
                            className="bg-primary rounded-circle d-flex align-items-center justify-content-center"
                            style={{ width: "50px", height: "50px" }}
                          >
                            <i className="fas fa-users text-white fs-5"></i>
                          </div>
                        </div>

                      </div>
                      <div>
                        <Chart
                          type="area"
                          height={120}
                          options={getAreaChartOptions("#007bff")}
                          series={[
                            {
                              name: "Total",
                              data: [
                                AllData.data.length / 3,
                                AllData.data.length / 2,
                                AllData.data.length,
                              ],
                            },
                          ]}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Active Panel Card */}
              <div className="col-12 col-sm-6 col-lg-4">
                <div className="card shadow-sm ">
                  <div className="card-body ">
                    <div className="d-flex align-items-center">
                      <div className="flex-grow-1">
                        <div>
                          <h6 className="card-title mb-1 fw-normal">Total Active Panel</h6>
                          <h2 className="mb-0 fw-bold">{activeUsersCount}</h2>
                        </div>
                      </div>
                      <div className="flex-shrink-0 me-3">
                        <div
                          className="bg-success rounded-circle d-flex align-items-center justify-content-center"
                          style={{ width: "50px", height: "50px" }}
                        >
                          <i className="fas fa-user-check text-white fs-5"></i>
                        </div>
                      </div>

                    </div>
                    <div className=" d-flex align-items-center">

                      <Chart
                        type="area"
                        height={120}
                        options={getAreaChartOptions("#28a745")}
                        series={[
                          {
                            name: "Active",
                            data: [
                              activeUsersCount / 3,
                              activeUsersCount / 2,
                              activeUsersCount,
                            ],
                          },
                        ]}
                      />

                    </div>
                  </div>
                </div>
              </div>

              {/* Inactive Panel Card */}
              <div className="col-12 col-sm-6 col-lg-4">
                <div className="card shadow-sm ">
                  <div className="card-body">
                    <div className="d-flex align-items-center">
                      <div className="flex-grow-1">
                        <h6 className="card-title mb-1 fw-normal">Total Inactive Panel</h6>
                        <h2 className="mb-0 fw-bold">{inActiveUserCount}</h2>
                      </div>
                      <div className="flex-shrink-0 me-3">
                        <div
                          className="bg-warning rounded-circle d-flex align-items-center justify-content-center"
                          style={{ width: "50px", height: "50px" }}
                        >
                          <i className="fas fa-user-times text-white fs-5"></i>
                        </div>
                      </div>

                    </div>
                    <div className=" d-flex align-items-center">
                      <Chart
                        type="area"
                        height={120}
                        options={getAreaChartOptions("#ffc107")}
                        series={[
                          {
                            name: "Inactive",
                            data: [
                              inActiveUserCount / 3,
                              inActiveUserCount / 2,
                              inActiveUserCount,
                            ],
                          },
                        ]}
                      />

                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Column Chart Section */}
            {/* <div className="row mt-4">
              <div className="col-12">
                <div className="card shadow-sm ">
                  <div className="card-body">
                    <h5 className="mb-3">Panel Overview</h5>
                    <Chart type="bar" height={350} options={columnChartOptions} series={columnChartSeries} />
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        ) : (
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body text-center py-5">
                  <h5>Dashboard content for other routes</h5>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </Content>
  );
};

export default Dashboard;
